import type { ReactElement } from 'react'
import { AgentAskCard, type AgentKind } from './AgentAskCard'
import { AgentsShell } from './AgentsShell'
import { AgentsSmsDashboard } from './AgentsSmsDashboard'
import { AgentsVoiceDashboard } from './AgentsVoiceDashboard'
import { useAgentAccess } from './useAgentAccess'

/** The practice's products decide: its dashboard when it has the agent, the ask card when not. */
function AgentPage({ kind }: { kind: AgentKind }): ReactElement {
  const access = useAgentAccess()
  const Dashboard = kind === `voice` ? AgentsVoiceDashboard : AgentsSmsDashboard
  if (access[kind]) return <Dashboard />
  return <AgentsShell>{!access.loading && <AgentAskCard kind={kind} />}</AgentsShell>
}

export function AgentsVoicePage(): ReactElement {
  return <AgentPage kind="voice" />
}

export function AgentsSmsPage(): ReactElement {
  return <AgentPage kind="sms" />
}
